import RecentProjects from '../../components/RecentProjects/RecentProjects';
import { Container } from '@mui/material';
import Layout from '../../components/Layout/Layout';
import './Home.scss';

const Home = () => {
    return (
        <Layout>
            <Container maxWidth='md'>{<RecentProjects />}</Container>
        </Layout>
    );
};

export default Home;
